module.exports = __webpack_public_path__ + "static/media/arrow-down.d7baee1f.svg";